import { gql } from '@apollo/client';

export const UPDATE_CHILDREN_NEW_MODEL = gql`
  mutation updateChildrenNewModel($input: UpdateChildrenNewModelInput!){
    updateChildrenNewModel(input: $input) {
      guardianId
      managedBy
      children {
        institutionType
        institutionId
        institutionName
        hierarchyType
        hierarchyId
        hierarchyName
        gradeLevel
        schoolYear
        schoolType
        childUid
        community
        postalCode
        status
      }
    }
  }
`
